import { schema } from 'normalizr';

import { processNetwork } from '../strategies/network';

export const networkSchema = new schema.Entity('networks', {}, { processStrategy: processNetwork });
